import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/admin/feature-flags`;

  /** What this venue may use: its own rows, already intersected with the global kill switch. */
  getEnabledFlags(): Observable<string[]> {
    return this.http.get<string[]>(this.apiUrl);
  }

  /**
   * The globally active codes, venue-independent. Read for the platform-wide flags only
   * (see `PlatformWideFlagCodes`), which have no per-complex row to be found in the list above.
   * The endpoint is unauthenticated because the player app reads the same list.
   */
  getPlatformFlags(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiUrl}/v1/feature-flags`);
  }
}
